<div class="container-fluid p-0">
  <div class="hpanel">
    <div class="panel-body b-r-6">
      <div class="card">
        <div class="card-header p-10-30">
          <h6> Manage Business Contacts for your organization</h6>
        </div>
        <div class="card-body">
          <ng-container *ngIf="isBusinessOrEnterpriseUser; else showUpgradeMessage">
            <app-plan-card [cards]="allocationCards" [TOTAL]="PLANMAX"></app-plan-card>
            <div class="row">
              <div class="col-sm-12">
                <app-customer-search [placeholder]="'Search by business name or email'"></app-customer-search>
              </div>
              <div class="custom-datatable col-lg-12 col-md-12 col-sm-12">
                <!-- Empty state -->
                <div *ngIf="listToShow.length === 0" class="datatable-empty-state">
                  <app-nodata-found
                    [title]="['No business contacts found']"
                    [screen]="'EMPTY'"
                    [buttonShow]="false">
                  </app-nodata-found>
                </div>

                <!-- Datatable with data -->
                <div *ngIf="listToShow.length > 0">
                  <ngx-datatable #sortTable  (sort)="onSort($event)" class="bootstrap" [rows]="listToShow" [columnMode]="'force'" [headerHeight]="40"
                    [footerHeight]="50" rowHeight="auto" [selectAllRowsOnPage]="false" [externalPaging]="true"
                    [count]="params.total" [scrollbarH]="true" [offset]="params.page - 1" [limit]="10"
                    (select)='onSelect($event)' (page)="nextPage($event)">
                    <ngx-datatable-column cellClass="colValuesync" name="Business Name" prop="businessName">
                      <ng-template let-row="row" ngx-datatable-cell-template>
                        <a class="listinglink" [routerLink]="['/user-management/businessContacts/businessConnectEdit']"
                          [queryParams]="getNetworkParams(row)">
                          {{ row.businessName }}
                        </a>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column cellClass="colValuesync" name="Owner"
                      prop="businessOwner"></ngx-datatable-column>
                    <ngx-datatable-column cellClass="colValuesync" name="Email"
                      prop="businessEmail"></ngx-datatable-column>
                    <ngx-datatable-column cellClass="colValuesync" name="Role">
                      <ng-template ngx-datatable-cell-template>
                        <span>Super Admin</span>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column cellClass="colValuesync" name="Business Type" prop="type">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        <span>{{ (row.type | networkTypeLabel) || 'N/A' }}</span>
                      </ng-template>
                    </ngx-datatable-column>
  
  
                    <ngx-datatable-column [width]="200" cellClass="colValuesync" name="Network Name"
                      prop="businessNetworks">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        <div class="network-container" [attr.title]="getTooltipText(row.businessNetworks)">
                          <span  style="max-width:131px;">{{ getNetworkDisplayName(row.businessNetworks).name || 'N/A'}}</span>
                          <span *ngIf="getNetworkDisplayName(row.businessNetworks).count > 0" class="network-count-box">
                            +{{ getNetworkDisplayName(row.businessNetworks).count }}
                          </span>
                        </div>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column cellClass="colValuesync" name="Partner Since" prop="startDate">
                      <ng-template ngx-datatable-cell-template let-row="row">
                        <label>
                          {{ row.startDate ? (row.startDate | timezoneDate:'MM/dd/yyyy') : 'N/A' }}
                        </label>
                      </ng-template>
                    </ngx-datatable-column>
  
                    <ngx-datatable-column cellClass="colValuesync" name="Last Active" prop="lastLoggedIn">
                      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        <label>
                          {{row.lastLoggedIn | timezoneDate:'MM/dd/yyyy'}}
                        </label>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column cellClass="colValuesync" name="Status" prop="connectionStatus">
                      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        <label [ngClass]="{
                            'connected': row.connectionStatus === 'CONNECTED',
                            'request-sent': row.connectionStatus === 'REQUEST_SENT',
                            'request-received': row.connectionStatus === 'REQUEST_RECEIVED',
                            'inactive-status-table': ['INACTIVE', 'REJECTED', 'CANCELLED'].includes(row.connectionStatus)
                          }">
                          {{ value === 'REQUEST_SENT' ? 'Requested' :
                          value === 'REQUEST_RECEIVED' ? 'Request Received' :
                          value | underscoreRemovePipe }}
                        </label>
                      </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [width]="150" cellClass="colValuesync" name="Actions" prop="name">
                      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                        <div class="wrapper">
                          <span class="action-items">
                            <ng-icon name="tablerEye" class="svg-position" (click)="openViewModal(row)"></ng-icon>
                          </span>
                          <span class="action-items">
                            <ng-icon name="tablerPencil" [routerLink]="['/user-management/businessContacts/businessConnectEdit']"
                              [queryParams]="getNetworkParams(row)" routerLinkActive="router-link-active"
                              class="svg-position"></ng-icon>
                          </span>
                          <span class="action-items" [matMenuTriggerFor]="menu" aria-label="More options">
                            <ng-icon name="tablerDots" class="svg-position"></ng-icon>
                          </span>
                          <mat-menu #menu="matMenu" >
                            <button id="business_contacts_accept_button" *ngIf="row.connectionStatus === 'REQUEST_RECEIVED'" mat-menu-item
                              (click)="openmodalofcontact(row)">Accept</button>
                            <button id="business_contacts_reject_button" *ngIf="row.connectionStatus === 'REQUEST_RECEIVED'" mat-menu-item
                              (click)="handleInvite(row, 'REJECT')">Reject</button>
  
                            <button id="business_contacts_remove_button" *ngIf="['CONNECTED', 'INACTIVE'].includes(row.connectionStatus)" mat-menu-item
                              (click)="removeUserContact(row)">Remove Contact</button>
  
                            <button id="business_contacts_cancel_request_button" class="business-contacts-menu-item" *ngIf="row.connectionStatus === 'REQUEST_SENT'" mat-menu-item
                              (click)="handleInvite(row, 'CANCEL')">Cancel Request</button>
                          </mat-menu>
                        </div>
                      </ng-template>
                    </ngx-datatable-column>
                  </ngx-datatable>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-template #showUpgradeMessage>
            <app-upgrade-message
              [allocationCards]="allocationCards">
            </app-upgrade-message>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>

<app-common-modal *ngIf="showModal" [openmodal]="openbusinessModal" [businessDetails]="businessDetails"
  [b2bnetworkcarddata]="(supplierBusinessId || customerBusinessId) ? null : { email: selectedBusinessEmail, id: businessId}" [title]="selectedItem" [type]="'ADD'"
  [supplierBusinessId]="supplierBusinessId"
  [customerBusinessId]="customerBusinessId"
  [customerBusinessName]="customerBusinessName"
  (response)="closeModal($event)"></app-common-modal>
